module.exports = __webpack_public_path__ + "img/tips2@x2.26ed48ab.png";